import { type PageModel } from 'survey-core';

export const obfuscatePageNumber = (page: PageModel) => {
  return Buffer.from(page.num.toString()).toString('base64');
};
